<template>
  <div>
    <div class="w-full full-login">
      <div class="block sm:flex justify-center align-items-center">
        <form
          @submit.prevent="sendOtp"
          class="xl:h-auto flex justify-center"
          v-if="!token"
        >
          <div
            class="my-10 mb-4 mx-4 px-4 py-8 bg-white rounded-md sm:w-9/12 w-full"
            style="box-shadow: 0px 4px 50px 0px #00000026"
          >
            <div
              class="px-2 inline-flex cursor-pointer"
              @click="$router.back()"
            >
              <ChevronLeftIcon class="block mx-auto text-theme-4" />
              <div class="text-center text-sm text-theme-4 font-medium">
                Regresar
              </div>
            </div>
            <img
              v-if="urlOriginIsBrandIn"
              alt="COTIZADOR"
              class="-intro-x -mt-14"
              style="display: block; margin: auto; width: 200px"
              :src="require(`@/assets/images/COT-img/logo-brand-in.png`)"
            />
            <img
              v-else
              alt="COTIZADOR"
              class="-intro-x -mt-14"
              style="display: block; margin: auto; width: 200px"
              :src="require(`@/assets/images/COT-img/logo.png`)"
            />
            <div class="intro-x mt-8 px-8">
              <div class="intro-x text-theme-2 text-center text-base">
                Ingresa el código de verificación que enviamos al correo:
                {{ email }}
              </div>
            </div>
            <div class="intro-x mt-8 px-8">
              <div class="intro-x text-theme-2 text-left mb-1">
                Código de verificación
              </div>
              <input
                id="validation-form-2"
                v-model.trim="otp"
                type="text"
                required
                class="intro-x login__input form-control py-3 px-4 border-theme-3 block mb-2"
                :class="{ 'border-theme-6': v$.otp.$error }"
                placeholder="6 dígitos"
                :maxlength="6"
                :minlength="6"
              />
              <template v-if="v$.otp.$errors">
                <div
                  v-for="(error, index) in v$.otp.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  <strong v-if="error.$validator === 'required'"
                    >El campo otp es requerido</strong
                  >
                  <strong v-else> El campo otp debe tener 6 caracteres </strong>
                </div>
              </template>
            </div>
            <div class="intro-x mt-5 xl:mt-8 text-center px-8">
              <button
                type="submit"
                :disabled="v$.$invalid"
                class="btn btn-quotation-login text-base py-3 px-4 w-60 border-0"
              >
                Siguiente
              </button>
            </div>
            <div
              class="intro-x mt-10 text-theme-4 text-center text-base mx-8 pb-4"
            >
              <button
                type="button"
                class="text-cpa-blue-link hover:underline text-center disabled:no-underline text-lg cursor-pointer disabled:cursor-not-allowed"
                @click="sendEmail"
                :disabled="Boolean(currentTime)"
              >
                <span v-if="!currentTime"> Reenviar código </span>
                <span v-else> Reenviar código en: {{ currentTime }} </span>
              </button>
            </div>
          </div>
        </form>
        <form
          @submit.prevent="createPassword"
          class="xl:h-auto flex justify-center"
          v-else
        >
          <div
            class="my-10 mb-4 mx-4 px-4 py-8 bg-white rounded-md sm:w-11/12 w-full"
            style="box-shadow: 0px 4px 50px 0px #00000026"
          >
            <img
              v-if="urlOriginIsBrandIn"
              alt="COTIZADOR"
              class="-intro-x -mt-16"
              style="display: block; margin: auto; width: 200px"
              :src="require(`@/assets/images/COT-img/logo-brand-in.png`)"
            />
            <img
              v-else
              alt="COTIZADOR"
              class="-intro-x -mt-16"
              style="display: block; margin: auto; width: 200px"
              :src="require(`@/assets/images/COT-img/logo.png`)"
            />
            <div class="intro-x mt-8 px-8">
              <div class="intro-x text-theme-2 text-center text-base">
                Para finalizar y activar tu cuenta crea tu contraseña.
              </div>
            </div>
            <div class="intro-x mt-8 px-8">
              <span class="text-xs">Nueva contraseña</span>
              <div class="input-group mt-1">
                <input
                  :type="inputPasswordShow ? 'text' : 'password'"
                  class="form-control p-3 text-base"
                  placeholder="Nueva contraseña"
                  style="border-right-width: 0"
                  ref="password"
                  v-model="password"
                  @cut.prevent
                  @copy.prevent
                  @paste.prevent
                  required
                />
                <div
                  class="input-group-text flex cursor-pointer"
                  style="border-left-width: 0; background: transparent"
                  @click="
                    changeInputShowPassword({
                      ref: 'password',
                      input: 'inputPasswordShow'
                    })
                  "
                >
                  <EyeIcon class="w-4 h-4 my-auto" v-if="!inputPasswordShow" />
                  <EyeOffIcon class="w-4 h-4 my-auto" v-else />
                </div>
              </div>
            </div>
            <div class="intro-x mt-3 px-10 text-xs flex flex-col">
              <span>
                Debe incluir
                <span :class="{ 'text-theme-6': !passwordHasMinLenght }">
                  mínimo 8 caracteres
                </span>
                y cumplir 3 de estas 4 características:
              </span>
              <span
                class="mt-1 flex"
                :class="{ 'opacity-30': !passwordHasUpperCase }"
              >
                <CheckCircleIcon class="w-3 h-3 my-auto mr-1" />Al menos una
                mayúscula
              </span>
              <span
                class="mt-1 flex"
                :class="{ 'opacity-30': !passwordHasLowerCase }"
              >
                <CheckCircleIcon class="w-3 h-3 my-auto mr-1" />
                Al menos una minúscula
              </span>
              <span
                class="mt-1 flex"
                :class="{ 'opacity-30': !passwordHasNumber }"
              >
                <CheckCircleIcon class="w-3 h-3 my-auto mr-1" />Al menos un
                número
              </span>
              <span
                class="mt-1 flex"
                :class="{ 'opacity-30': !passwordHasSpecialCharacter }"
              >
                <CheckCircleIcon class="w-3 h-3 my-auto mr-1" />Al menos un
                caracter especial (#$%&_) o puntuación (,.)
              </span>
            </div>

            <div class="intro-x mt-6 px-8">
              <span class="text-xs">Confirmar contraseña</span>
              <div class="input-group mt-1 mb-2">
                <input
                  :type="inputConfirmPasswordShow ? 'text' : 'password'"
                  class="form-control p-3 text-base"
                  placeholder="Confirmar contraseña"
                  style="border-right-width: 0"
                  ref="confirm-password"
                  v-model="confirmPassword"
                  @cut.prevent
                  @copy.prevent
                  @paste.prevent
                  required
                />
                <div
                  class="input-group-text flex cursor-pointer"
                  style="border-left-width: 0; background: transparent"
                  @click="
                    changeInputShowPassword({
                      ref: 'confirm-password',
                      input: 'inputConfirmPasswordShow'
                    })
                  "
                >
                  <EyeIcon
                    class="w-4 h-4 my-auto"
                    v-if="!inputConfirmPasswordShow"
                  />
                  <EyeOffIcon class="w-4 h-4 my-auto" v-else />
                </div>
              </div>
              <span
                class="text-xs ml-1 text-theme-6"
                v-if="
                  password?.length >= 8 &&
                  confirmPassword?.length >= 8 &&
                  password !== confirmPassword
                "
                >Las contraseñas no coinciden</span
              >
            </div>
            <div class="intro-x block text-theme-2 text-base mt-5 px-8">
              <div class="flex items-center mr-auto mb-1">
                <input
                  type="checkbox"
                  class="form-check-input border mr-3 ring-transparent"
                  required
                  v-model="tacs"
                />
                <label class="select-none text-base"
                  >Acepto el
                  <router-link
                    :to="{ name: 'privacity' }"
                    tag="a"
                    class="cursor-pointer text-theme-4"
                  >
                    aviso de privacidad
                  </router-link>
                  y los<br />
                  <router-link
                    :to="{ name: 'conditions' }"
                    tag="a"
                    class="cursor-pointer text-theme-4"
                  >
                    términos y condiciones
                  </router-link>
                </label>
              </div>
            </div>
            <div class="intro-x mt-5 xl:mt-8 text-center">
              <button
                type="submit"
                class="btn btn-quotation-login text-base py-3 px-4 w-60 border-0"
                :disabled="!checkValidationPassword"
              >
                Crear
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { minLength, maxLength, required } from '@vuelidate/validators'
import { getFirstErrorMessage } from '@/utils/tools'

export default {
  data() {
    return {
      email: '',
      otp: '',
      token: undefined,
      inputPasswordShow: false,
      inputConfirmPasswordShow: false,
      password: undefined,
      confirmPassword: undefined,
      tacs: undefined,
      currentTime: 0
    }
  },
  setup() {
    return { v$: useVuelidate() }
  },
  beforeMount() {
    this.email = this.$route.params.email
    cash('html').addClass('unauthenticated')
  },
  validations() {
    return {
      otp: {
        required,
        minLength: minLength(6),
        maxLenght: maxLength(6),
        $autoDirty: true
      }
    }
  },
  validationConfig: {
    $lazy: false
  },
  methods: {
    async sendOtp() {
      this.$store.commit('main/setShowSpinner', true)
      try {
        const response = await this.axios.post('otp/validate-otp', {
          email: this.email,
          code: this.otp
        })
        this.token = response.data.temporal_token
      } catch (error) {
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
      }
    },
    async sendEmail() {
      this.initCount()
      this.$store.commit('main/setShowSpinner', true)
      try {
        await this.axios.post('otp/send-otp-email-to-activate-user', {
          email: this.email
        })
        this.$toast.success(
          'El código de verificación se ha enviado con éxito',
          {
            position: 'top'
          }
        )
      } catch (error) {
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
      }
    },
    changeInputShowPassword({ ref, input }) {
      this[input] = !this[input]
      this.$refs[ref].focus()
      setTimeout(() => {
        const length = this.$refs[ref].value.length
        this.$refs[ref].setSelectionRange(length, length)
      })
    },
    async createPassword() {
      this.$store.commit('main/setShowSpinner', true)
      try {
        await this.axios.post(
          '/auth/modify-password',
          {
            new_password: this.password
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        this.$store.commit(
          'main/setAccountActivate',
          'Tu cuenta se activó correctamente'
        )
        this.$router.push('/login')
      } catch (error) {
        console.log(error)
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
      }
    },
    updateCounter() {
      if (this.currentTime != 0) {
        this.currentTime -= 1
        setTimeout(() => this.updateCounter(), 1000)
      }
    },
    initCount() {
      this.currentTime = 60
      this.updateCounter()
    }
  },
  computed: {
    passwordHasMinLenght() {
      return this.password?.length >= 8
    },
    passwordHasLowerCase() {
      return /[a-z]/.test(this.password || '')
    },
    passwordHasUpperCase() {
      return /[A-Z]/.test(this.password || '')
    },
    passwordHasNumber() {
      return /\d/.test(this.password || '')
    },
    passwordHasSpecialCharacter() {
      const specialChars = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/
      return specialChars.test(this.password || '')
    },
    checkValidationPassword() {
      return (
        this.tacs &&
        this.password?.length >= 8 &&
        this.password === this.confirmPassword &&
        this.passwordHasLowerCase +
          this.passwordHasUpperCase +
          this.passwordHasNumber +
          this.passwordHasSpecialCharacter >=
          3
      )
    },
    urlOriginIsBrandIn() {
      const currentHost = (window.location?.host || '').replace(/^www\./, '')
      const brandInDomain = (process.env.VUE_APP_BRAND_IN_DOMAIN || '').replace(
        /^www\./,
        ''
      )
      return currentHost === brandInDomain
    }
  },
  created() {
    this.initCount()
  }
}
</script>

<style scoped>
.full-login {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: center;
}

.form-check-input {
  width: 24px !important;
  height: 24px !important;
}
.form-check-input[type='checkbox']:checked {
  background: #faa306 !important;
  border: 1px solid #faa306;
}
</style>
